import { render, staticRenderFns } from "./NotAccessibleModal.vue?vue&type=template&id=5d1fd5a0"
import script from "./NotAccessibleModal.vue?vue&type=script&lang=js"
export * from "./NotAccessibleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports